module.exports = __webpack_public_path__ + "img/97.9.e29d23bd.png";